import { isUndefined } from '@aloft/toolkit-shared';

import { ValueFormatter } from '../../types.js';

export const noop: ValueFormatter = (value: any) => {
  if (isUndefined(value)) {
    return { str: [''] };
  }
  return { str: [value.toString()] };
};
